import { IonButton, IonIcon, IonInput, IonItem, IonLabel, IonModal, IonRadio, IonRadioGroup, IonSpinner, IonToast, isPlatform, useIonViewDidEnter } from '@ionic/react';

import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { arrowForwardOutline, keyOutline, mailOutline, phonePortraitOutline, shieldCheckmarkOutline } from 'ionicons/icons';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  confirmarLogin,
  confirmarLoginPin,
  enviarEmail,
  enviarSms,
  requestService
} from '../../../Utils/Services';

import { MessageContext } from '../../../contexts/MessageContext';
import { authentication } from '../../../firebase-config';
import PINInput from '../../Empresa/Home/pages/Inicio/PINInput';

import CadastroLayout from '../CadastroLayout/CadastroLayout';
import ModalHeader from '../../../components/Modal/ModalHeader';
import './ValidarOtp.css';

const ValidarOtp: React.FC = () => {

  const history = useHistory();

  // --- Estados principais ---
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const [botaoAtivo, setBotaoAtivo] = useState(true);
  const [textBotao, setTextBotao] = useState("Validar");

  const [codigo, setCodigo] = useState("");
  const [codigoValido, setCodigoValido] = useState(false);
  const [confirmation, setConfirmation] = useState<any>();

  const [desabilitarEnviarEmail, setDesabilitarEnviarEmail] = useState(false);

  const [pinCadastrado, setPinCadastrado] = useState<boolean | undefined>(undefined);

  const [pin, setPin] = useState(['', '', '', '']);
  const [erroPin, setErroPin] = useState(false);

  const { setLoja } = useContext(MessageContext);

  const inputRef = useRef<any>(null);

  // Modal Esqueci o PIN
  const [showModalEsqueci, setShowModalEsqueci] = useState(false);
  const [metodoAcesso, setMetodoAcesso] = useState("email");
  // Novo: controla se está no fluxo de recuperação (após handleEnviarMetodo)
  const [recuperacaoOtp, setRecuperacaoOtp] = useState(false);


  // -----------------------------------
  // FLUXO DO PIN
  // -----------------------------------
  const prepararFluxoPin = () => {
    setPinCadastrado(true);
    setBotaoAtivo(true);
    setTextBotao("Validar PIN");
    setPin(['', '', '', '']);
    setErroPin(false);
    setDesabilitarEnviarEmail(false);
  };


  // -----------------------------------
  // FLUXO OTP / SMS
  // -----------------------------------
  const iniciarValidacaoSms = () => {
    let fcmAtivo = window.localStorage.getItem("fcmAtivo");

    if (!isPlatform('ios') && fcmAtivo === "true") {

      const nome = 'divRecaptcha' + new Date().toLocaleTimeString();
      const elementToAdd = document.createElement("div");
      elementToAdd.setAttribute('id', nome);

      const div = document.getElementById('recaptcha-container');
      if (div) div.append(elementToAdd);

      const recpVerify = new RecaptchaVerifier(
        nome,
        { 'size': 'invisible', 'callback': () => { } },
        authentication
      );

      signInWithPhoneNumber(authentication, '+' + window.localStorage.getItem("telefone"), recpVerify)
        .then((confirmationResult) => {
          setConfirmation(confirmationResult);

          setTimeout(() => {
            inputRef.current?.setFocus();
          }, 200);

          setBotaoAtivo(true);
        })
        .catch(() => {
          setTextToast("Não foi possível enviar o SMS.");
          setShowToast(true);
          history.goBack();
        });

    } else {
      setTimeout(() => {
        inputRef.current?.setFocus();
      }, 200);
      setBotaoAtivo(true);
    }
  };


  const prepararFluxoOtp = () => {
    setPinCadastrado(false);
    setTextBotao("Validar");
    setBotaoAtivo(false);
    setCodigo("");
    setCodigoValido(false);
    setErroPin(false);
    setDesabilitarEnviarEmail(false);

    const recaptchaContainer = document.getElementById('recaptcha-container');
    if (recaptchaContainer) recaptchaContainer.innerHTML = "";

    iniciarValidacaoSms();
  };


  // -----------------------------------
  // QUANDO ABRE A TELA
  // -----------------------------------
  useIonViewDidEnter(() => {
    const temPin = window.localStorage.getItem("pinCadastrado") === "true";

    setPinCadastrado(temPin);

    if (temPin) prepararFluxoPin();
    else prepararFluxoOtp();
  });


  // -----------------------------------
  // VALIDAÇÕES
  // -----------------------------------
  const validarCodigo = (valor: string): boolean => {
    const codigoNumerico = valor.replace(/\D/g, '');
    return codigoNumerico.length === 6;
  };

  const isOtpBloqueado = (error: any) => {
    const codigoErro = error?.codigo || error?.code || error?.response?.codigo;
    const mensagemErro = error?.message || error?.response?.message;

    return codigoErro === "OTP_BLOQUEADO" ||
      mensagemErro?.toLowerCase()?.includes("código bloqueado");
  };

  const getMensagemOtpBloqueado = (error: any) => {
    const mensagemErro = error?.message || error?.response?.message;
    const segundosRestantes = error?.segundosRestantes ?? error?.response?.segundosRestantes;

    if (segundosRestantes) {
      const minutosRestantes = Math.max(1, Math.ceil(segundosRestantes / 60));
      return `Código bloqueado por excesso de tentativas. Tente novamente em ${minutosRestantes} minuto${minutosRestantes > 1 ? 's' : ''}.`;
    }

    return mensagemErro || "Código bloqueado por excesso de tentativas. Tente novamente em 10 minutos.";
  };


  const validarPin = () => {
    const completo = pin.every(d => d !== "");
    if (!completo) {
      setTextToast("Por favor, preencha todos os 4 dígitos do PIN.");
      setShowToast(true);
      return;
    }

    setErroPin(false);
    setBotaoAtivo(false);
    setTextBotao("Aguarde...");
    loginComPin();
  };

  const validar = () => {
    if (pinCadastrado) {
      validarPin();
      return;
    }

    if (!codigo || !codigoValido) {
      setTextToast("Por favor, insira um código válido de 6 dígitos");
      setShowToast(true);
      return;
    }

    const codigoNumerico = codigo.replace(/\D/g, '');

    if (codigoNumerico.length !== 6) {
      setTextToast("O código deve ter exatamente 6 dígitos");
      setShowToast(true);
      return;
    }

    if (inputRef.current) inputRef.current.setBlur();

    setBotaoAtivo(false);
    setTextBotao("Aguarde...");

    let fcmAtivo = window.localStorage.getItem("fcmAtivo");

    if (!isPlatform('ios') && fcmAtivo == "true") {
      confirmation.confirm(codigo)
        .then((result: any) => {
          const user = result?.user;
          login(user?.accessToken);
        })
        .catch(() => {
          login();
        });
    } else {
      login();
    }
  };


  // -----------------------------------
  // LOGIN POR PIN
  // -----------------------------------
  function loginComPin(accessToken?: any) {
    const objectRequest = {
      pin: pin.join(''),
      accessToken,
      chaveContato: window.localStorage.getItem("chaveContato") || "0",
      telefone: window.localStorage.getItem("telefone")
    };

    requestService(
      confirmarLoginPin.url.replace("{cpf}", window.localStorage.getItem("cpf") || ""),
      {
        method: confirmarLoginPin.method,
        headers: [["token", window.localStorage.getItem("token")]],
        body: JSON.stringify(objectRequest),
        credentials: 'include'
      },
      history,
      (response: any) => {
        window.localStorage.setItem("empresa", response.gsi2pk);
        setLoja(response.gsi2pk);

        window.localStorage.setItem("logado", "true");
        if (response.lojas)
          window.localStorage.setItem("lojas", JSON.stringify(response.lojas));

        if (response.servicoPrincipal)
          window.localStorage.setItem("servicoPrincipal", response.servicoPrincipal);

        if (response.servicoTipo)
          window.localStorage.setItem("servicoTipo", response.servicoTipo);

        if (response.servicoTipoPlural)
          window.localStorage.setItem("servicoTipoPlural", response.servicoTipoPlural);

        if (response.configWorkflow)
          window.localStorage.setItem("configWorkflow", JSON.stringify(response.configWorkflow));

        if (response.nomeInternoMesaOuComanda)
          window.localStorage.setItem("nomeInternoMesaOuComanda", response.nomeInternoMesaOuComanda);

        if (response.nomeInternoMesasOuComandas)
          window.localStorage.setItem("nomeInternoMesasOuComandas", response.nomeInternoMesasOuComandas);

        if (response.nomeLinhaDoTempo)
          window.localStorage.setItem("nomeLinhaDoTempo", response.nomeLinhaDoTempo);

        if (response.polos)
          window.localStorage.setItem("polos", JSON.stringify(response.polos));

        if (response.naoAgrupar)
          window.localStorage.setItem("naoAgrupar", response.naoAgrupar);

        if (response.esconderValoresProjeto)
          window.localStorage.setItem("esconderValoresProjeto", response.esconderValoresProjeto);

        if (response.nome)
          window.localStorage.setItem("nome", response.nome);

        if (response.naoOperacao)
          window.localStorage.setItem("naoOperacao", response.naoOperacao);

        if (response.configWorkflowVenda)
          window.localStorage.setItem("configWorkflowVenda", JSON.stringify(response.configWorkflowVenda));

        if (response.empresaMarca)
          window.localStorage.setItem("empresaMarca", response.empresaMarca);

        if (response.parceria)
          window.localStorage.setItem("parceria", response.parceria);

        if (response.acessos)
          window.localStorage.setItem("acessos", JSON.stringify(response.acessos));

        if (typeof response.pinCadastrado !== 'undefined')
          window.localStorage.setItem("pinCadastrado", String(response.pinCadastrado));

        setBotaoAtivo(true);
        setPin(['', '', '', '']);
        setCodigo("");
        setCodigoValido(false);
        setTextBotao("Validar PIN");

        history.push("/empresa/inicio");
      },
      (error: any) => {
        const codigoErro = error?.codigo || error?.code || error?.response?.codigo;
        const mensagemErro = error?.message || error?.response?.message;
        const tentativasRestantes = error?.tentativasRestantes ?? error?.response?.tentativasRestantes;
        const pinBloqueado =
          codigoErro === "PIN_BLOQUEADO" ||
          mensagemErro?.toLowerCase()?.includes("bloqueado");

        if (pinBloqueado) {
          setTextToast("PIN bloqueado por excesso de tentativas. Para acessar novamente, utilize a opção \"Esqueci meu PIN\".");
        } else if (tentativasRestantes !== undefined) {
          setTextToast(`${mensagemErro || "PIN inválido"}. Tentativas restantes: ${tentativasRestantes}`);
        } else {
          setTextToast(mensagemErro || "PIN inválido");
        }
        setShowToast(true);
        setPin(['', '', '', '']);
        setErroPin(true);
        setBotaoAtivo(true);
        setTextBotao("Validar PIN");
      }
    );
  }


  // -----------------------------------
  // LOGIN POR OTP
  // -----------------------------------
  function login(accessToken?: any) {
    const codigoNumerico = codigo.replace(/\D/g, '');

    const objectRequest = {
      otp: codigoNumerico,
      accessToken,
      chaveContato: window.localStorage.getItem("chaveContato") || "0",
      telefone: window.localStorage.getItem("telefone")
    };

    requestService(
      confirmarLogin.url.replace("{cpf}", window.localStorage.getItem("cpf") || ""),
      {
        method: confirmarLogin.method,
        headers: [["token", window.localStorage.getItem("token")]],
        body: JSON.stringify(objectRequest),
        credentials: 'include'
      },
      history,
      (response: any) => {
        window.localStorage.setItem("empresa", response.gsi2pk);
        setLoja(response.gsi2pk);

        window.localStorage.setItem("logado", "true");

        if (response.lojas)
          window.localStorage.setItem("lojas", JSON.stringify(response.lojas));

        if (response.servicoPrincipal)
          window.localStorage.setItem("servicoPrincipal", response.servicoPrincipal);

        if (response.servicoTipo)
          window.localStorage.setItem("servicoTipo", response.servicoTipo);

        if (response.servicoTipoPlural)
          window.localStorage.setItem("servicoTipoPlural", response.servicoTipoPlural);

        if (response.configWorkflow)
          window.localStorage.setItem("configWorkflow", JSON.stringify(response.configWorkflow));

        if (response.nomeInternoMesaOuComanda)
          window.localStorage.setItem("nomeInternoMesaOuComanda", response.nomeInternoMesaOuComanda);

        if (response.nomeInternoMesasOuComandas)
          window.localStorage.setItem("nomeInternoMesasOuComandas", response.nomeInternoMesasOuComandas);

        if (response.nomeLinhaDoTempo)
          window.localStorage.setItem("nomeLinhaDoTempo", response.nomeLinhaDoTempo);

        if (response.polos)
          window.localStorage.setItem("polos", JSON.stringify(response.polos));

        if (response.naoAgrupar)
          window.localStorage.setItem("naoAgrupar", response.naoAgrupar);

        if (response.esconderValoresProjeto)
          window.localStorage.setItem("esconderValoresProjeto", response.esconderValoresProjeto);

        if (response.nome)
          window.localStorage.setItem("nome", response.nome);

        if (response.naoOperacao)
          window.localStorage.setItem("naoOperacao", response.naoOperacao);

        if (response.configWorkflowVenda)
          window.localStorage.setItem("configWorkflowVenda", JSON.stringify(response.configWorkflowVenda));

        if (response.empresaMarca)
          window.localStorage.setItem("empresaMarca", response.empresaMarca);

        if (response.parceria)
          window.localStorage.setItem("parceria", response.parceria);

        if (response.acessos)
          window.localStorage.setItem("acessos", JSON.stringify(response.acessos));

        if (typeof response.pinCadastrado !== 'undefined')
          window.localStorage.setItem("pinCadastrado", String(response.pinCadastrado));

        setBotaoAtivo(true);
        setCodigo("");
        setCodigoValido(false);
        setTextBotao("Validar");

        history.push("/empresa/inicio");
      },
      (error: any) => {
        const mensagemErro = error?.message || error?.response?.message;
        const tentativasRestantes = error?.tentativasRestantes ?? error?.response?.tentativasRestantes;

        if (isOtpBloqueado(error)) {
          setTextToast(getMensagemOtpBloqueado(error));
          setDesabilitarEnviarEmail(true);
          setBotaoAtivo(false);
        } else if (tentativasRestantes !== undefined) {
          setTextToast(`${mensagemErro || "Código inválido"}. Tentativas restantes: ${tentativasRestantes}`);
          setBotaoAtivo(true);
        } else {
          setTextToast(mensagemErro || "Código inválido");
          setBotaoAtivo(true);
        }
        setShowToast(true);
        setCodigo("");
        setCodigoValido(false);
        setTextBotao("Validar");
      }
    );
  }


  // -----------------------------------
  // ENVIO POR EMAIL
  // -----------------------------------
  const enviarPorEmail = () => {
    requestService(
      enviarEmail.url.replace("{cpf}", window.localStorage.getItem("cpf") || ""),
      {
        method: enviarEmail.method,
        headers: [["token", window.localStorage.getItem("token")]],
        credentials: 'include'
      },
      history,
      (response: any) => {
        setTextToast(response.message);
        setShowToast(true);
        setDesabilitarEnviarEmail(true);
      },
      (error: any) => {
        if (isOtpBloqueado(error)) {
          setTextToast(getMensagemOtpBloqueado(error));
          setDesabilitarEnviarEmail(true);
          setBotaoAtivo(false);
        } else {
          setTextToast("Ocorreu um erro ao enviar o e-mail");
        }
        setShowToast(true);
      }
    );
  };


  // -----------------------------------
  // ENVIO POR SMS (stub)
  // -----------------------------------
  const enviarPorSms = () => {
    requestService(
      enviarSms.url.replace("{cpf}", window.localStorage.getItem("cpf") || ""),
      {
        method: enviarSms.method,
        headers: [["token", window.localStorage.getItem("token")]],
        credentials: 'include'
      },
      history,
      (response: any) => {
        setTextToast(response.message || "SMS enviado com sucesso");
        setShowToast(true);
      },
      (error: any) => {
        if (isOtpBloqueado(error)) {
          setTextToast(getMensagemOtpBloqueado(error));
          setDesabilitarEnviarEmail(true);
          setBotaoAtivo(false);
        } else {
          setTextToast("Erro ao enviar SMS");
        }
        setShowToast(true);
      }
    );
  };


  // -----------------------------------
  // BOTÃO DO MODAL
  // -----------------------------------
  const handleEnviarMetodo = () => {
    setShowModalEsqueci(false);
    setRecuperacaoOtp(true); // Ativa modo recuperação
    prepararFluxoOtp();
    if (metodoAcesso === "email") enviarPorEmail();
    else enviarPorSms();
  };


  // -----------------------------------
  // INPUT DO CÓDIGO
  // -----------------------------------
  function onChangeCodigo(e: any) {
    e.persist();
    e.preventDefault();

    const valor = e.target.value;
    const codigoNumerico = valor.replace(/\D/g, '');
    const codigoLimitado = codigoNumerico.slice(0, 6);

    setCodigo(codigoLimitado);
    setCodigoValido(validarCodigo(codigoLimitado));

    if (e.keyCode === 13) {
      if (botaoAtivo && codigoLimitado.length === 6) validar();
    }
  }




  const canalCodigo = recuperacaoOtp && metodoAcesso === 'email' ? 'e-mail' : 'SMS';

  return (
    <CadastroLayout
      showHero={false}
      headerTitle="Confirmar acesso"
      eyebrow="ACESSO À SUA CONTA"
      title="Confirme seu acesso"
      description="Falta só uma etapa para acessar sua conta no Xeguei."
      backHref="/login"
      icon={shieldCheckmarkOutline}
      badge="Acesso seguro"
    >
      <section className="otp-card" aria-labelledby="otp-title">
        {pinCadastrado === undefined ? <div className="otp-loading" role="status"><IonSpinner /><p>Preparando seu acesso…</p></div> : <>
          <span className="otp-card-icon"><IonIcon icon={pinCadastrado ? keyOutline : mailOutline} aria-hidden="true" /></span>
          <h1 id="otp-title">{pinCadastrado ? 'Digite seu PIN' : 'Valide seu código'}</h1>
          <p className="otp-description">{pinCadastrado
            ? 'Informe seu PIN de 4 dígitos para continuar.'
            : `Insira o código de 6 dígitos recebido por ${canalCodigo}.`}</p>

          {pinCadastrado ? <div className="otp-pin-field">
            <PINInput
              className="otp-pin"
              length={4}
              error={erroPin}
              idPrefix="pin-validacao-otp-input"
              onChange={(pinDigitado: string) => {
                const arr = pinDigitado.split('');
                while (arr.length < 4) arr.push('');
                setPin(arr.slice(0, 4));
              }}
            />
            {erroPin && <p className="otp-field-error" role="alert">Não foi possível validar o PIN. Confira o aviso e tente novamente ou recupere seu acesso.</p>}
          </div> : <div className="cadastro-field otp-code-field">
            <label htmlFor="otp-code">Código de verificação</label>
            <IonInput
              id="otp-code"
              aria-label="Código de verificação"
              ref={ref => (inputRef.current = ref)}
              type="text"
              inputmode="numeric"
              autocomplete="one-time-code"
              maxlength={6}
              required
              value={codigo}
              onKeyUp={onChangeCodigo}
              onIonInput={(e: any) => {
                const valor = String(e.target.value || '').replace(/\D/g, '').slice(0, 6);
                setCodigo(valor);
                setCodigoValido(validarCodigo(valor));
              }}
            />
          </div>}

          <IonButton className="cadastro-primary otp-primary" expand="block" disabled={!botaoAtivo} onClick={() => {
            if (pinCadastrado && !pin.every(d => d !== '')) {
              setTextToast('Preencha todos os campos do PIN');
              setShowToast(true);
              return;
            }
            if (!pinCadastrado && (!codigo || codigo.length !== 6)) {
              setTextToast('Preencha o código de 6 dígitos');
              setShowToast(true);
              return;
            }
            validar();
          }}>{textBotao}<IonIcon slot="end" icon={arrowForwardOutline} aria-hidden="true" /></IonButton>
          {pinCadastrado ? <IonButton className="otp-secondary" expand="block" fill="clear" onClick={() => setShowModalEsqueci(true)}>Esqueci meu PIN</IonButton>
            : !recuperacaoOtp && <IonButton className="otp-secondary" expand="block" fill="clear" disabled={desabilitarEnviarEmail} onClick={enviarPorEmail}><IonIcon slot="start" icon={mailOutline} aria-hidden="true" />Enviar código por e-mail</IonButton>}
          <p className="otp-security-note"><IonIcon icon={shieldCheckmarkOutline} aria-hidden="true" />Não compartilhe seu PIN ou código de acesso.</p>
        </>}
      </section>

      <div id="recaptcha-container" />
      <IonToast isOpen={showToast} onDidDismiss={() => setShowToast(false)} message={textToast} position="middle" duration={3000} />
      <IonModal className="otp-recovery-modal" isOpen={showModalEsqueci} onDidDismiss={() => setShowModalEsqueci(false)}>
        <div className="otp-recovery-panel">
          <ModalHeader title="Esqueci meu PIN" layout="responsive" onDismiss={() => setShowModalEsqueci(false)} />
          <div className="otp-recovery-body">
            <span className="otp-card-icon"><IonIcon icon={keyOutline} aria-hidden="true" /></span>
            <h2>Recupere seu acesso</h2>
            <p>Escolha como deseja receber o código de verificação nos contatos cadastrados na sua conta.</p>
            <IonRadioGroup className="otp-methods" aria-label="Como deseja receber o código?" value={metodoAcesso} onIonChange={e => setMetodoAcesso(e.detail.value)}>
              <IonItem lines="none" className={`otp-method ${metodoAcesso === 'email' ? 'is-selected' : ''}`}>
                <IonIcon className="otp-method-icon" slot="start" icon={mailOutline} aria-hidden="true" />
                <IonLabel><h3>E-mail</h3><p>Receba o código no seu e-mail.</p></IonLabel>
                <IonRadio slot="end" value="email" aria-label="E-mail" />
              </IonItem>
              <IonItem lines="none" className={`otp-method ${metodoAcesso === 'sms' ? 'is-selected' : ''}`}>
                <IonIcon className="otp-method-icon" slot="start" icon={phonePortraitOutline} aria-hidden="true" />
                <IonLabel><h3>SMS</h3><p>Receba o código no seu celular.</p></IonLabel>
                <IonRadio slot="end" value="sms" aria-label="SMS" />
              </IonItem>
            </IonRadioGroup>
          </div>
          <footer className="otp-recovery-footer">
            <IonButton expand="block" onClick={handleEnviarMetodo}>Avançar<IonIcon slot="end" icon={arrowForwardOutline} aria-hidden="true" /></IonButton>
          </footer>
        </div>
      </IonModal>
    </CadastroLayout>
  );
};

export default ValidarOtp;
